"use client"

import { CommonStylesProps } from "@/(admin)/modules/ui-builder/config/lib/commonCSSProps"
import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import { EventItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/EventCarousel/types"
import { mapEventToItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/EventCarousel/utils/utils"
import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { getEvents } from "@/services/event-services"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { useEffect, useState } from "react"
import { EventCard } from "./EventCard"

const EVENT_GRID_PAGE_SIZE = 3

export interface EventGridProps extends CommonStylesProps {}

export const RenderConfig: ComponentConfig<EventGridProps> = {
  render: ({ className, styles, responsiveType }) => {
    const [events, setEvents] = useState<EventItem[]>([])
    const [loading, setLoading] = useState(true)
    const id = `post-grid-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    // params.locale phải đứng trước: storeLocale mặc định "vi" (luôn truthy) nên nếu
    // để trước sẽ nuốt locale của URL và khoá block ở tiếng Việt trên site public.
    const locale = (params?.locale as string) || storeLocale || "vi"

    useEffect(() => {
      const fetchEvents = async () => {
        setLoading(true)
        try {
          // page/pageSize phải nằm ở top-level: getEvents chỉ đọc searchTerms.page và
          // searchTerms.pageSize, key `pagination` bị bỏ qua nên trước đây block luôn
          // lấy về pageSize mặc định 20 thay vì 3.
          const response = await getEvents({
            page: 1,
            pageSize: EVENT_GRID_PAGE_SIZE,
            publicationState: "live",
            locale,
          })
          setEvents(response.data.map(mapEventToItem))
        } catch (error) {
          console.error(error)
          setEvents([])
        } finally {
          setLoading(false)
        }
      }

      fetchEvents()
    }, [locale])

    return (
      <>
        {responsiveCSS}
        <div className={`w-full ${className || ""}`}>
          <div className="max-w-[1304px] mx-auto sm:px-2 px-4">
            <div className={`grid grid-cols-1 md:grid-cols-3 sm:gap-6 gap-10`}>
              {events.length > 0 &&
                events.map(event => <EventCard key={event.id} event={event} locale={locale} />)}
            </div>
          </div>
        </div>
      </>
    )
  },
}

export default RenderConfig
